module.exports = __webpack_public_path__ + "static/media/eduTechImg1@2x.5348158c.jpg";